module.exports = "https://cdn.littlereply.com/tt/resource/lh_toast_process.297f634daea51132b9f47b168497f274.png";